// extracted by mini-css-extract-plugin
export default {"Octicon":"blankslate-error-message-module__Octicon--dmKiH","Text":"blankslate-error-message-module__Text--zvjLP"};